import styled from 'styled-components';
import { saasModernTheme } from 'common/theme/saasModern';
import { Typography } from '@mui/material';

export const StyledTitle = styled(Typography)`
  font-family: ${saasModernTheme.fontFamily};
  font-weight: 900;
  font-size: 48px;
  line-height: normal;

  strong {
    background: ${saasModernTheme.customColor.backgroundTextGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media screen and(max-width: 950px) {
    font-size: 38px;
  }
  @media screen and (max-width: 600px) {
    font-size: 30px;
  }
`;

export const TestimonialItem = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: ${saasModernTheme.gradiantShadow};
  padding: 24px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto;
  transition: all 0.3s ease;

  @media (max-width: 950px) {
    max-width: 90%;
    padding: 8px;
  }
`;

export const TestimonialCite = styled.cite`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

export const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
`;

export const AuthorName = styled.h3`
  font-family: ${saasModernTheme.fontFamily};
  text-align: left;
  margin: 0 0 5px;
  color: var(--Text-Primary, #111927);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const AuthorRole = styled.span`
  font-style: normal;
  text-align: left;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 14px;
  color: #777777;
`;

export const AuthorImage = styled.div`
  width: 50px;
  height: 50px;
  display: block;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 6px 30px 0px rgba(39, 79, 117, 0.2);
  margin-bottom: 0;
  position: relative;

  @media (max-width: 575px) {
    width: 60px;
    height: 45px;
  }
`;

export const TestimonialBlockQuote = styled.blockquote`
  text-align: center;
  font-family: ${saasModernTheme.fontFamily};
  color: var(--Text-Secondary, #636f81);
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  margin: 0;
  padding: 0;

  p {
    margin: 0;
  }
`;

export const HeaderTemoignage = styled.header`
  text-align: center;
  margin-top: ${saasModernTheme.space[8]}px;
  margin-bottom: ${saasModernTheme.space[13]}px;
`;

export const TestimonialDescription = styled.p`
  color: var(--Text-Secondary, #636f81);
  text-align: center;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const CarouselNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  z-index: 1;
`;

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #666;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f8f8f8;
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }
  @media (max-width: 950px) {
    margin-inline: 10px;
  }
`;

export const TestimonialsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 30px 0;

  .testimonials-wrapper {
    display: flex;
    gap: 20px;
    width: 100%;
    overflow: hidden;
    padding: 10px 0;

    @media (max-width: 950px) {
      flex-direction: column;
      align-items: center;
      gap: 0;
    }
  }
`;
